<template>
  <div style="display: flex; align-items: flex-start; margin-bottom: 8px; flex-direction: column">
    <div style="display: flex; align-items: center">
      <c-label
        :required="required"
        class="title"
        style="width: initial; display: flex; line-height: 16px"
        :weight="500"
        ><slot></slot
      ></c-label>
      <lego-icon
        v-if="help"
        style="display: flex; margin-left: 6px"
        iconType="df"
        icon="info"
        size="16"
      />
    </div>
    <slot name="message"></slot>
    <lego-tooltip v-if="help" :right="true" :mouseOver="true">
      <slot name="tooltip">
        <div v-html="help"></div>
      </slot>
    </lego-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: null
    }
  }
};
</script>
